import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const CategorySidebar = ({ categories, selectedCategory, onCategorySelect }) => {
  const [expandedCategories, setExpandedCategories] = useState([1, 2, 3]);

  const toggleCategory = (categoryId) => {
    if (expandedCategories?.includes(categoryId)) {
      setExpandedCategories(expandedCategories?.filter(id => id !== categoryId));
    } else {
      setExpandedCategories([...expandedCategories, categoryId]);
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 sticky top-24">
      <h3 className="text-sm font-semibold text-foreground mb-4 flex items-center gap-2">
        <Icon name="FolderTree" size={16} />
        Categories
      </h3>
      <div className="space-y-1">
        {categories?.map((category) => (
          <div key={category?.id}>
            <button
              onClick={() => {
                toggleCategory(category?.id);
                onCategorySelect(category?.id === selectedCategory ? null : category?.id);
              }}
              className={`w-full flex items-center justify-between p-2 rounded-md transition-smooth ${
                selectedCategory === category?.id
                  ? 'bg-primary/10 text-primary' :'hover:bg-muted text-foreground'
              }`}
            >
              <div className="flex items-center gap-2">
                <Icon name={category?.icon} size={16} />
                <span className="text-sm font-medium">{category?.name}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xs text-muted-foreground">{category?.articleCount}</span>
                <Icon
                  name="ChevronRight"
                  size={14}
                  className={`transition-smooth ${
                    expandedCategories?.includes(category?.id) ? 'rotate-90' : ''
                  }`}
                />
              </div>
            </button>

            {/* Subcategories */}
            {expandedCategories?.includes(category?.id) && category?.subcategories && (
              <div className="ml-6 mt-1 space-y-1">
                {category?.subcategories?.map((sub) => (
                  <button
                    key={sub?.id}
                    onClick={() => onCategorySelect(sub?.id)}
                    className={`w-full flex items-center justify-between p-2 rounded-md text-sm transition-smooth ${
                      selectedCategory === sub?.id
                        ? 'bg-primary/10 text-primary' :'hover:bg-muted text-muted-foreground'
                    }`}
                  >
                    <span>{sub?.name}</span>
                    <span className="text-xs">{sub?.articleCount}</span>
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategorySidebar;